<lib-tooltip [customAnchor]="true" [placement]="'above'">
  <span customAnchor><ng-content></ng-content></span>
  <ng-content select="[tooltip]"></ng-content>
</lib-tooltip>